module.exports = __webpack_public_path__ + "static/Logo-M-small-248be2a200458bb570fbb73cdad3bb6c.png";